import { Student } from '@/apis/family_application/requests'
import { Button } from '@/app/common/components/Button'
import { SuccessCircleIcon } from '@/app/common/icons/general'
import { useTranslation } from 'react-i18next'

type Props = {
  onContinueClick: () => void,
  selectedStudent: Student
}

function ApplicationSubmitted({onContinueClick, selectedStudent}: Props) {
  const { t: translate } = useTranslation()

  return (
    <div className='max-w-lg'>
      <div className="flex flex-col items-center justify-center mt-6 min-h-[40vh]">
        {/* Check Icon */}
        <SuccessCircleIcon />
        <h1 className="text-xl font-medium text-gray-900 mt-3">
          {translate('application_renew_submitted', { 
            student_name: `${selectedStudent.first_name} ${selectedStudent.last_name}`
          })}
        </h1>

      </div>
      <div className="text-center h-full flex mt-6">
        <div className="w-full">
          <Button className='w-full' onClick={onContinueClick}>
            {translate('continue')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ApplicationSubmitted
